import '../plugins/retinaPlugin';

export default function initRetinaCover() {
	jQuery('.bg-stretch').retinaCover();
}